module.exports = __webpack_public_path__ + "img/youtube_grey.02bed647.svg";